import { replaceUriParameter } from "api/endpoints";
import { useQuery } from "@tanstack/react-query";
import { PaginationMetaConverter } from "domain/converter/pagination-meta.converter";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import getInstance from "../../../utils/rest";
import { GroupContractConverter } from "../../../domain/converter/group-contract.converter";
import { IGroupContract } from "../../../domain/group/group-contract";
import { IPaginationInputMeta, IPaginationMeta } from "../../../domain/pagination/pagination-meta";
import { IGroupContractListModel } from "../../../models/group/group-contract.model";
import { SharedQueryKeys } from "../query-keys";

export interface IGroupContractsResponse {
  pomContracts: IGroupContract[];
  meta: IPaginationMeta;
}

const getGroupContracts = async (
  erpNumber: string,
  paginationMeta: IPaginationInputMeta,
): Promise<IGroupContractsResponse> => {
  const url = replaceUriParameter(RestEndpoints.ContractsForGroup, "erpNumber", erpNumber);
  const response = await getInstance().get<IGroupContractListModel>(url, {
    params: {
      page: paginationMeta.page,
      pageSize: paginationMeta.pageSize,
    },
  });
  const { pomContracts, meta } = response.data;
  return {
    pomContracts: pomContracts.map(GroupContractConverter.toDomain),
    meta: PaginationMetaConverter.toDomain(meta),
  };
};

export const useGetGroupContracts = (
  erpNumber: string,
  paginationInputMeta: IPaginationInputMeta,
) => {
  return useQuery({
    queryKey: [SharedQueryKeys.GetGroupContracts, erpNumber, paginationInputMeta],
    queryFn: () => getGroupContracts(erpNumber, paginationInputMeta),
    staleTime: ReactQueryConfig.staleTime,
  });
};
